module.exports = __webpack_public_path__ + "img/20190527162415QQ截图20190524163035.9681dc6d.png";